
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
    VipPaySettingService,
    RegistrationPackageDto,
    VipPriceDto,
    CardHandlingRegistrationPackage,
} from "@/api/service-proxies";
import EditTextDialog from "./edit-text-dialog.vue";

class PayDetail {
    settingId!: number;
    schoolId: number;
    shcoolName!: string;
    packageDto: RegistrationPackageDto;
}

@Component({
    name: "EditRegistrationDialog",
    components: {
        EditTextDialog,
    },
})
export default class extends Vue {
    private dialogVisible = false;
    private payService = new VipPaySettingService();
    payDeatail: PayDetail;
    private isUpdating = false;
    changeVisible: boolean = false;
    addPackageModel = new CardHandlingRegistrationPackage({
        id: 0,
        sortNumber: 0,
        cardHandlingRegistrationId: 0,
        exclusivePrice: 0,
        introduce: "",
        isShow: true,
        marketPrice: 0,
        tenantId: 0,
        title: "",
        updatePackageType: 1,
    });
    requiredData = new RegistrationPackageDto();
    options = [
        {
            value: 0,
            label: "办新卡",
        },
        {
            value: 1,
            label: "携号转网",
        },
        {
            value: 2,
            label: "联通老用户",
        },
    ];
    inputValue2: any = ""; // 正文内容  textarea框值
    registrationType = "0";

    success(str, registrationType, index, type) {
        console.log(
            registrationType,
            index,
            type,
            "-----监听文本改变样式"
        );
        console.log( Number(registrationType))
        if (type == 1) {
            this.requiredData.cardHandlingRegistrations[
                Number(registrationType)
            ].cardHandlingRegistrationPackage[index].title = str;
        } else if (type == 2) {
            this.requiredData.cardHandlingRegistrations[
                Number(registrationType)
            ].cardHandlingRegistrationPackage[index].introduce = str;
        } else if (type == 3) {
            this.requiredData.cardHandlingRegistrations[
                Number(registrationType)
            ].ruleComment = str;
        }
    }
    constructor() {
        super();
        this.payDeatail = new PayDetail();
    }
    listenEventHide() {
        this.changeVisible = false;
    }

    //修改回显的数据展示
    open(settingId, schoolId, shcoolName, result) {
        this.addPackageModel.updatePackageType = 1;
        this.dialogVisible = true;
        this.payDeatail.shcoolName = shcoolName;
        this.payDeatail.schoolId = schoolId;
        this.payDeatail.settingId = settingId;
        this.requiredData = result;
        this.registrationType = this.requiredData.registrationType.toString();
        var userSelection;
    }
    gotoEdit(text1, index, type) {
       
        // 1为标题，2介绍 ，规则
        (this.$refs.eidtTextDialog as EditTextDialog).open(
            text1,
            this.registrationType,
            index,
            type
        );
    }

    //添加套餐

    addItemPackage(packageList) {
        this.addPackageModel.tenantId = packageList.tenantId;
        this.addPackageModel.cardHandlingRegistrationId = packageList.id;
        packageList.cardHandlingRegistrationPackage.push(this.addPackageModel);
    }

    // tab切换
    handleClick(tab, event) {
        this.registrationType = tab.name;
    }
    // 上移
    upMove(index, list, item) {
        console.log("index:" + index);
        if (index > 0) {
            list[index].sortNumber = index - 1;
            console.log(list[index]);
            list[index - 1].sortNumber = index;
            console.log(list[index - 1]);
            list[index] = list.splice(index - 1, 1, list[index])[0];
        }
    }
    // 下移
    moveDown(list, index, item) {
        if (index != list.length - 1) {
            list[index].sortNumber = index + 1;
            list[index + 1].sortNumber = index;
            list[index] = list.splice(index + 1, 1, list[index])[0];
        }
    }
    //删除（置底，updatePackageType为删除标记
    delListIndex(index, list, item) {
        list[index].updatePackageType = 2;

        // 置底
        if (index != list.length - 1) {
            list.push(list.splice(index, 1)[0]);
        }
    }

    // 关闭弹框
    hideModal() {
        this.$emit("listenEventHide");
        this.dialogVisible = false;
    }

    stateChange() {
        alert();
    }

    submit() {
        console.log(JSON.stringify(this.requiredData))
        if(this.requiredData.days == null)
        {
            this.requiredData.days = 0
        }

        this.payService
            .updateRegistrationPackages(this.requiredData)
            .then((result) => {
                this.isUpdating = false;
                this.$emit("success");
                this.dialogVisible = false;
                this.$message.success("修改成功");
            })
            .catch(() => {
                this.isUpdating = false;
            });
    }

    private handleSwitchChange() {
        this.payDeatail = JSON.parse(
            JSON.stringify(this.payDeatail)
        ) as PayDetail;
    }
}
